import { render, staticRenderFns } from "./CardIcon.vue?vue&type=template&id=66853eea&"
import script from "./CardIcon.vue?vue&type=script&lang=ts&"
export * from "./CardIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports